const SvgFabExpand: React.FC = () => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_24_554)">
        <circle cx="32" cy="32" r="24" className={"fill-secondary"} />
      </g>
      <g clipPath="url(#clip0_24_554)">
        <path
          d="M25.25 23C23.464 23 22 24.464 22 26.25V34.25V37.2676C22 38.2434 23.195 38.8526 23.9844 38.2793C23.9847 38.2793 23.985 38.2793 23.9854 38.2793L26.1455 36.708C26.5575 38.0308 27.7972 39 29.25 39H35.5059L40.0146 42.2793C40.015 42.2793 40.0153 42.2793 40.0156 42.2793C40.805 42.8526 42 42.2434 42 41.2676V38.25V30.25C42 28.464 40.536 27 38.75 27H38V26.25C38 24.464 36.536 23 34.75 23H25.25ZM25.25 24.5H34.75C35.725 24.5 36.5 25.275 36.5 26.25V31.75C36.5 32.725 35.725 33.5 34.75 33.5H28.25C28.0914 33.5 27.9369 33.5502 27.8086 33.6436L23.5 36.7773V34.25V26.25C23.5 25.275 24.275 24.5 25.25 24.5ZM38 28.5H38.75C39.725 28.5 40.5 29.275 40.5 30.25V38.25V40.7773L36.1914 37.6436C36.0632 37.5502 35.9086 37.5 35.75 37.5H29.25C28.275 37.5 27.5 36.725 27.5 35.75V35.7227L28.4941 35H34.75C36.536 35 38 33.536 38 31.75V28.5Z"
          fill="white"
          className="dark-fill-secondary-inner"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_24_554"
          x="0"
          y="0"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_554"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_554"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_24_554">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(20 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgFabExpand;
